import React from 'react';

const SubsidiaryCard = ({ name, description, link, logoPlaceholder }) => {
  return (
    <div className="card-hover glass-card rounded-xl overflow-hidden border border-gray-200 bg-white/80 backdrop-blur-sm h-full flex flex-col group">
      <div className="p-8 flex flex-col h-full">
        <div className="flex justify-center mb-6">
          <img 
            src={logoPlaceholder} 
            alt={`${name} logo`} 
            className="h-20 w-auto object-contain transition-transform duration-300 group-hover:scale-110"
          />
        </div>
        <h3 className="text-xl font-bold text-gray-800 mb-3 text-center group-hover:text-blue-700 transition-colors duration-300">{name}</h3>
        <p className="text-gray-600 text-center mb-6 flex-grow leading-relaxed text-sm">{description}</p>
        <div className="text-center mt-auto">
          <a 
            href={link || '#'} 
            className="inline-block bg-blue-600 text-white hover:bg-blue-700 font-semibold px-6 py-2.5 rounded-lg transition-all duration-300 ease-in-out w-full text-center text-sm group-hover:shadow-lg"
          >
            Learn More
          </a>
        </div>
      </div>
    </div>
  );
};

export default SubsidiaryCard;